import { authedApiFetch } from '../../utils/Api';

export const action = async ({ params, request }) => {
	try {
		const { jobId } = params;

		const formData = await request.formData();
		const recordType = formData.get('recordType');
		const recordId = formData.get('recordId');
		const updatedData = formData.get('updatedData');

		if (!jobId || !recordType || !recordId || !updatedData) {
			throw new Error('Missing required parameters');
		}

		const parsedData = JSON.parse(updatedData);

		console.log('Updating record:', {
			jobId,
			recordType,
			recordId,
			updatedData,
		});

		// Ensure recordId is URL-escaped to handle special characters
		const escapedRecordId = encodeURIComponent(recordId);

		await authedApiFetch({
			endpoint: `/email/jobs/${jobId}/records/${escapedRecordId}`,
			method: 'PATCH',
			payload: {
				type: recordType,
				record_data: parsedData,
			},
		});

		return {
			success: true,
			message: 'Successfully updated record',
			record: parsedData,
		};
	} catch (error) {
		console.error('Error updating record:', error);
		return {
			success: false,
			message: 'Failed to update record',
			error: error.message,
		};
	}
};
